// extracted by mini-css-extract-plugin
export default {"recipesContainer":"Recipes_recipesContainer__nQiyo","footerTrash":"Recipes_footerTrash__GB+sV","trashBtn":"Recipes_trashBtn__sjAVS","trashIcon":"Recipes_trashIcon__UdeIC"};